import { LockerType } from '@/types/LockerType'
import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'

type Props = {
  data: LockerType | undefined
}

export const LockerSummaryCard: React.FC<Props> = ({ data }: Props) => {
  return (
    <>
      <Row className='mb-4 mt-3 mt-md-0'>
        <Col lg={4} sm={12}>
          <Card className='bg-white rounded gap-2 p-4 '>
            <Row className='d-flex align-items-center'>
              <Col xs={2}>
                <i className='ri-grid-line ri-2x'></i>
              </Col>
              <Col xs={10} className='ps-0'>
                <h4 className='mb-0'>Total casiers</h4>
              </Col>
              <Col className='text-end'>
                <span className=''>{data?.slotsInfos?.total}</span>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col lg={4} sm={12} className='my-3 my-md-0'>
          <Card className='bg-white rounded gap-2 p-4 '>
            <Row className='d-flex align-items-center'>
              <Col xs={2}>
                <i className='ri-checkbox-line ri-2x'></i>
              </Col>
              <Col xs={10} className='ps-0'>
                <h4 className='mb-0'>Casiers disponibles</h4>
              </Col>
              <Col className='text-end'>
                <span className=''>{data?.slotsInfos?.available}</span>
              </Col>
            </Row>
          </Card>
          {/* <div className='bg-white rounded'>
            <div className=''>
              <div className='rounded'>
                <i className='ri-checkbox-line ri-2x'></i>
              </div>
            </div>
            <div className=''>
              <h5 className='mb-0'>Casiers disponibles</h5>
              <h6 className='mb-0 ms-1'>{data?.slotsInfos?.available}</h6>
            </div>
          </div> */}
        </Col>
        <Col lg={4} sm={12}>
          <Card className='bg-white rounded gap-2 p-4 '>
            <Row className='d-flex align-items-center'>
              <Col xs={2}>
                <i className='ri-door-lock-box-line ri-2x'></i>
              </Col>
              <Col xs={10} className='ps-0'>
                <h4 className='mb-0'>Casiers réservés</h4>
              </Col>
              <Col className='text-end'>
                <span className=''>{data?.slotsInfos?.rented}</span>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}
